import React, { createContext, useState, useEffect } from 'react';
const apiUrl = process.env.REACT_APP_API_URL;
// Create a Context for the global state
export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      fetch(`${apiUrl}/categories/`)
        .then(response => response.json())
        .then(data => {
          setData(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setLoading(false);
        });
    }, []);
  
    return (
      <GlobalContext.Provider value={{ data, loading }}>
        {children}
      </GlobalContext.Provider>
    );
  };
  